module.exports = {"ziModal":5000,"ziHeader":4000,"ziCookiesConsent":3000};